import type { CSSProperties } from 'react';
import styled from 'styled-components';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { useGetSetBackground } from '@sorare/core/src/set';

import defaultBackground from './assets/default.webp';

const Root = styled.div`
  position: absolute;
  inset: 0;
  background: var(--bg-url) no-repeat center center;
  background-size: cover;
  z-index: 0;
`;

type Props = {
  golden?: boolean;
  rarityColor?: string;
  rarity: Rarity;
};
export const Background = ({ golden, rarityColor, rarity }: Props) => {
  const getSetBackground = useGetSetBackground();
  const setBg = getSetBackground();

  const baseBg =
    rarity === Rarity.common
      ? setBg.background
      : `url(${defaultBackground}) no-repeat center center / cover`;
  const baseBlend = setBg?.backgroundBlendMode || 'normal';

  const layers = [
    golden
      ? 'linear-gradient(#FFC534, #FFC534)'
      : 'linear-gradient(transparent, transparent)',
    ...(rarityColor ? [`linear-gradient(${rarityColor}, ${rarityColor})`] : []),
    baseBg,
  ];
  const blendModes = [
    'color',
    ...(rarityColor ? ['soft-light'] : []),
    baseBlend,
  ];

  return (
    <Root
      style={
        {
          background: layers.join(', '),
          backgroundBlendMode: blendModes.join(', '),
        } as CSSProperties
      }
    />
  );
};
